import copy from "copy-to-clipboard"
import { showSuccessNotification } from "./Notifications"

export const copyToClipboard = (item) => {
    copy(item)
    showSuccessNotification("Copied")
}